module.exports = __webpack_public_path__ + "static/media/Permias San Francisco Bay Area.5eed70de.png";